/**
 * Apply editorial display typography without mutating persisted source text.
 * Apostrophes in English titles are conventionally rendered as right single
 * quotation marks, including possessives and contractions.
 */
export const formatEditorialTitleForDisplay = (title: string): string => (
  title.replace(/'/g, '’')
)
